import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=fac6a21e"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fac6a21e')) {
      api.createRecord('fac6a21e', component.options)
    } else {
      api.reload('fac6a21e', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=fac6a21e", function () {
      api.rerender('fac6a21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/offlineblindDataOrder/edit/activity.vue"
export default component.exports